
define( 'system/js/view',[ 'jclass', 'jquery', 'dust', 'dust_helpers', 'dust_extra' ], function( Class, $, Dust ) {
	'use strict';

	/*
	===============================================================================
	Class: View
	===============================================================================
	*/

	var View = Class._extend( {

		/**
		 * Method: init
		 * @param {Object} aOptions
		 */

		init: function( aOptions ) {
			var options = aOptions || { };

			this._options = $.extend( true, {
				parent: null
			}, options );

			this._parent = this._options.parent;
			this._data = [ ];
		},

		/**
		 * Method: getParent
		 */

		getParent: function( ) {
			return this._parent;
		},

		/**
		 * Method: verbose
		 */

		verbose: function( ) {
			Dust.debugLevel = 'DEBUG';
		},

		/**
		 * Method: ajaxPartials
		 */

		ajaxPartials: function( ) {
			Dust.onLoad = function( aView, aCallback ) {
				var view = aView;

				if ( aView.indexOf( '.dust' ) === -1 ) {
					view += '.dust';
				}

				$.ajax( {
					type: 'get',
					url: _assets_base_url + view + '?t=' + Date.now( ), // eslint-disable-line no-undef
					success: function( aData ) {
						aCallback( null, aData );
					}
				} );
			};
		},

		/**
		 * Method: get
		 * @param {String} aPath
		 * @param {String} aHash
		 */

		get: function( aPath, aHash ) {
			if ( this._data.hasOwnProperty( aPath ) === true && this._data[ aPath ].hasOwnProperty( aHash ) === true ) {
				return this._data[ aPath ][ aHash ];
			}

			return false;
		},

		/**
		 * Method: create
		 * @param {Object} aView
		 */

		create: function( aView ) {
			if ( this._data.hasOwnProperty( aView.path ) === false ) {
				this._data[ aView.path ] = [ ];
			}

			this._data[ aView.path ][ aView.hash ] = this.load( aView );

			return this._data[ aView.path ][ aView.hash ];
		},

		/**
		 * Method: load
		 * @param {Object} aView
		 */

		load: function( aView ) {
			if ( aView.hasOwnProperty( 'html' ) === true && aView.html !== undefined && aView.html !== null && aView.html.length > 0 ) {
				Dust.loadSource( Dust.compile( aView.html, aView.path ) );
			}

			return this;
		},

		/**
		 * Method: render
		 * @param {String} aKey
		 * @param {Object} aData
		 * @param {Function} aCallback
		 */

		render: function( aKey, aData, aCallback ) {
			var stream = Dust.stream( aKey, aData ),
				callback = aCallback || function( aOutput ) { },
				output = '';

			stream.on( 'data', function( segment ) {
				output += segment;
			} ).on( 'end', function( ) {
				callback( output );
			} );
		},

		/**
		 * Method: empty
		 */

		empty: function( ) {
			this._data = [ ];

			return this;
		}
	} );

	return View;
} );

